import { Dice6 } from "lucide-react";
import Toggle from "./Toggle";

interface ScrambleToggleProps {
  enabled: boolean;
  onToggle: () => void;
  className?: string;
}

/**
 * Reusable scramble toggle button component using Radix UI Toggle.
 * Shows a dice icon that changes color based on scramble state.
 *
 * Now uses Radix UI Toggle primitive for better accessibility and state management.
 */
export default function ScrambleToggle({
  enabled,
  onToggle,
  className = "",
}: ScrambleToggleProps) {
  return (
    <Toggle
      pressed={enabled}
      onPressedChange={() => onToggle()}
      onClick={(e) => e.stopPropagation()}
      className={`p-0 transition-colors ${
        enabled
          ? "text-gray-300 hover:text-white data-[state=on]:text-gray-300 data-[state=on]:border-0"
          : "text-gray-600 hover:text-gray-500 data-[state=off]:text-gray-600 data-[state=off]:border-0"
      } ${className}`}
      title={enabled ? "Will scramble on refresh" : "Won't scramble on refresh"}
      aria-label={`Toggle scramble: ${enabled ? "enabled" : "disabled"}`}
    >
      <Dice6 className="w-6 h-6 sm:w-7 sm:h-7" />
    </Toggle>
  );
}
